class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);
function quickAddButton(){
  if(document.querySelectorAll('.grid-add-btn')){
    document.querySelectorAll('.grid-add-btn').forEach(function(grid_btn){
      grid_btn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        let variant_id = grid_btn.dataset.id;
        let error_grid_outer = grid_btn.closest('.snippet-card-product');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422){
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-bubble.cb-desk').innerHTML = cart_count;
                document.querySelector('.cart-bubble.cb-mb').innerHTML = '('+cart_count+')';
              }else{
                document.querySelector('.cart-bubble.cb-mb').innerHTML = '';
                document.querySelector('.cart-bubble.cb-desk').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });
  }
}
quickAddButton();

// ----------------animation


const animationObserverOptions = {
  rootMargin: "-100px",
};

const animationObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return;
    }

    entry.target.classList.add("animation-init");
    entry.target.addEventListener(
      "animationend",
      () => {
        entry.target.classList.add("animation-none");
      },
      {
        once: true,
      }
    );
    animationObserver.unobserve(entry.target);
  });
}, animationObserverOptions);

observeAnimationElements();

window.addEventListener("shopify:section:load", () => {
  observeAnimationElements();
});

function observeAnimationElements() {
  const animationElements = document.querySelectorAll(
    '[class*="js-animation-"]'
  );

  animationElements.forEach((animationElement) => {
    animationObserver.observe(animationElement);
  });
}


// ------cursor animation

if (document.getElementById('cursor-effect')) {
  const cursorEffect = document.getElementById('cursor-effect');
  cursorEffect.style.position = 'fixed';
  cursorEffect.style.display = 'none';
  
  const mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  
  const onMouseMove = (e) => {
    mouse.x = e.clientX;
    mouse.y = e.clientY;

    // Determine the position of the cursorEffect based on mouse position
    const offsetX = 10; // Offset to prevent overlap with the cursor
    if (mouse.x > window.innerWidth / 2) {
      // If mouse is on the right side, position cursorEffect to the left
      cursorEffect.style.transform = `translate(${mouse.x - cursorEffect.offsetWidth - offsetX}px, ${mouse.y}px)`;
    } else {
      // If mouse is on the left side, position cursorEffect to the right
      cursorEffect.style.transform = `translate(${mouse.x + offsetX}px, ${mouse.y}px)`;
    }
  };
  
  document.addEventListener('mouseover', (e) => {
    const target = e.target.closest('.hover-section');
    if (target) {
      const value = target.getAttribute('data-value');
      if (value) {
        cursorEffect.innerText = value;
        cursorEffect.style.display = 'block';
      }
    }
  });
  
  document.addEventListener('mousemove', (e) => {
    if (e.target.closest('.hover-section')) {
      cursorEffect.style.display = 'block'; 
    }
  });
  
  document.addEventListener('mouseout', (e) => {
    if (e.target.closest('.hover-section')) {
      cursorEffect.style.display = 'none'; 
    }
  });
  
  window.addEventListener('mousemove', onMouseMove);
}

// if (document.getElementById('cursor-effect')){
//   const cursorEffect = document.getElementById('cursor-effect');
//   cursorEffect.style.position = 'fixed';
//   cursorEffect.style.display = 'none';
  
//   const mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  
//   const onMouseMove = (e) => {
//     mouse.x = e.clientX;
//     mouse.y = e.clientY;
//     cursorEffect.style.transform = `translate(${mouse.x}px, ${mouse.y}px)`;
//   };
  
//   document.addEventListener('mouseover', (e) => {
//     const target = e.target.closest('.hover-section');
//     if (target) {
//       const value = target.getAttribute('data-value');
//       if (value) {
//         cursorEffect.innerText = value;
//         cursorEffect.style.display = 'block';
//       }
//     }
//   });
  
//   document.addEventListener('mousemove', (e) => {
//     if (e.target.closest('.hover-section')) {
//       cursorEffect.style.display = 'block'; 
//     }
//   });
  
//   document.addEventListener('mouseout', (e) => {
//     if (e.target.closest('.hover-section')) {
//       cursorEffect.style.display = 'none'; 
//     }
//   });
  
//   window.addEventListener('mousemove', onMouseMove);


// }


window.addEventListener("load", function () {
    const accessibilityLink = document.querySelector('a[href="#accessibility"]');

    if (accessibilityLink) {
      accessibilityLink.addEventListener("click", function (e) {
        e.preventDefault(); 
        if (typeof UserWay !== 'undefined' && typeof UserWay.widgetOpen === 'function') {
          UserWay.widgetOpen();
        } else {
          console.error("UserWay widget is not available.");
        }
      });
    } else {
      console.error("Accessibility link not found.");
    }
  });


// Cart Drawer Gift Wrap


document.addEventListener('DOMContentLoaded', function () {
  const giftCheckbox = document.getElementById('giftproduct');

  if (giftCheckbox) {
    giftCheckbox.addEventListener('change', function () {
      const isChecked = giftCheckbox.checked;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            "Gift wrap": isChecked 
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated with Gift wrap:', data.attributes);
      })
      .catch(error => {
        console.error('Failed to update gift wrap:', error);
      });
    });
  }
});
